import SectionProvider from '@builder/sections/SectionProvider'

export const name = 'Internal Embed Block'
export const group = 'internal-embed-block'
export const defaultOptions = {
  content: {
    code: {
      type: 'estage-internal-embed-mod',
      display: true,
      code: '',
      title: ''
    }
  }
}

export const previews = {
  left: null,
  right: null,
  main: require('@builder/assets/svg/previews/blanks/main-2.svg')
}

export default class Section extends SectionProvider {
  constructor (options = {}) {
    super('ElInternalEmbedBlock', options)

    this.name = name
    this.group = group
    this.hideFromSections = true
    this.defaultOptions = defaultOptions
  }
}